import React, { useEffect, useState } from "react";
import { useApp } from "@/context/AppContext";
import { api } from "@/lib/api";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { motion } from "framer-motion";
import { Camera } from "lucide-react";

export default function Photos() {
  const { eventId } = useApp();
  const [photos, setPhotos] = useState([]);
  const [active, setActive] = useState(null);

  useEffect(() => { api.photos(eventId).then(setPhotos); }, [eventId]);

  return (
    <div className="pt-16 px-4 pb-6">
      <div className="pt-4 pb-4">
        <span className="text-[11px] uppercase tracking-[0.24em] font-semibold text-[hsl(var(--pc-gold))]">Memories</span>
        <h1 className="font-serif text-4xl text-cream">Photos</h1>
        <p className="text-sm text-cream-dim mt-1">A gallery of moments from President's Club.</p>
      </div>
      <div data-testid="attendee-photos-gallery" className="columns-2 gap-3 [column-fill:_balance]">
        {photos.map((p, i) => (
          <motion.button key={p.id} data-testid="attendee-photos-photo" initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.3, delay: i * 0.04 }} onClick={() => setActive(p)} className="mb-3 block w-full overflow-hidden rounded-2xl border border-[hsl(var(--pc-line))]">
            <img src={p.url} alt={p.caption} className="w-full object-cover" />
          </motion.button>
        ))}
      </div>
      <Dialog open={!!active} onOpenChange={(o) => !o && setActive(null)}>
        <DialogContent data-testid="attendee-photos-lightbox" className="max-w-md p-0 overflow-hidden bg-black border-none">
          {active && (<div><img src={active.url} alt={active.caption} className="w-full object-contain max-h-[75vh]" /><div className="p-3 text-center text-sm text-white/90 bg-black"><Camera className="h-4 w-4 inline mr-1.5" />{active.caption}</div></div>)}
        </DialogContent>
      </Dialog>
    </div>
  );
}
